<script lang="ts">
	import type { WidgetState } from '../lib/widget.svelte';
	import type { WidgetTemplate } from '../lib/types';

	let { widget, mode = 'grid' }: { widget: WidgetState; mode?: 'grid' | 'carousel' } = $props();

	// Posición CSS de la marca de agua en el thumbnail (mismas reglas que el canvas)
	function watermarkStyle(template: WidgetTemplate): string {
		const watermark = template.config?.watermark;
		if (!watermark) return 'display:none';

		const [vertical, horizontal] =
			watermark.position === 'center' ? ['center', 'center'] : watermark.position.split('-');
		const padding = Math.round(watermark.padding_px / 6);
		const styles = [`width:${watermark.size_percent}%`, `opacity:${watermark.opacity}`];

		if (vertical === 'top') styles.push(`top:${padding}px`);
		else if (vertical === 'bottom') styles.push(`bottom:${padding}px`);
		else styles.push('top:50%');

		if (horizontal === 'left') styles.push(`left:${padding}px`);
		else if (horizontal === 'right') styles.push(`right:${padding}px`);
		else styles.push('left:50%');

		styles.push(
			`transform:translate(${horizontal === 'center' ? '-50%' : '0'}, ${vertical === 'center' ? '-50%' : '0'})`
		);
		return styles.join(';');
	}
</script>

<div class="ss-gallery {mode === 'carousel' ? 'ss-carousel' : ''}">
	{#each widget.data?.templates ?? [] as template (template.id)}
		<button
			type="button"
			class="ss-template"
			onclick={() => widget.selectTemplate(template)}
			aria-label={`Elegir plantilla ${template.name}`}
		>
			<span
				class="ss-template-bg"
				style="background-color: {template.config?.background?.color ?? '#e4e4e7'}"
			></span>
			{#if template.config?.background?.image_url}
				<img class="ss-bg-img" src={template.config.background.image_url} alt="" />
			{/if}
			<svg class="ss-silhouette" viewBox="0 0 100 100" fill="currentColor" aria-hidden="true">
				<circle cx="50" cy="32" r="17" />
				<path d="M15 100 Q15 62 50 62 Q85 62 85 100 Z" />
			</svg>
			{#if template.config?.watermark}
				<img class="ss-wm" src={template.config.watermark.url} alt="" style={watermarkStyle(template)} />
			{/if}
			<span class="ss-template-name">{template.name}</span>
		</button>
	{:else}
		<p style="grid-column: 1 / -1; font-size: 13px; color: var(--ss-muted); text-align: center;">
			Esta campaña no tiene plantillas activas.
		</p>
	{/each}
</div>
